<div class="custom-modal-layout upload-doc">
  <div class="modal-header">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Icon" />
    </div>
    <span class="title">Carregar documento</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="close()" />
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="p-fluid grid">
      <div class="field col-12">
        <label>Tipo de Documento</label>
        <p-select class="w-full" [options]="tipoDocOptions" optionLabel="designacao" optionValue="id"
          formControlName="TipoDocumento" [filter]="true" appendTo="body">
        </p-select>
        <div class="error-message" *ngIf="ctrl('TipoDocumento').touched && ctrl('TipoDocumento').invalid">
          Selecione o tipo de documento
        </div>
      </div>

      <div class="field col-12">
        <label>Estado do Documento</label>
        <p-select class="w-full" [options]="estadoDocOptions" optionLabel="designacao" optionValue="id"
          formControlName="EstadoDocumento" appendTo="body">
        </p-select>
        <div class="error-message" *ngIf="ctrl('EstadoDocumento').touched && ctrl('EstadoDocumento').invalid">
          Selecione o estado do documento
        </div>
      </div>

      <div class="field col-12">
        <label>Descrição (opcional)</label>
        <input pInputText class="w-full" placeholder="Observações..." formControlName="Descricao" />
      </div>

      <div class="field col-12">
        <label>Ficheiro</label>

        <!-- DROPZONE -->
        <div class="dropzone d-flex flex-column align-items-center" [class.dragover]="dragOver" (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

          <ng-container *ngIf="!file; else fileInfo">
            <i class="pi pi-upload text-2xl mb-2"></i>
            <div class="dz-text">
              Arraste e solte aqui ou
              <p-button type="button" class="linklike" pButton label="escolha um ficheiro" (click)="fileInput.click()">
              </p-button>
            </div>
            <small class="hint">Formatos: PDF• até {{ maxSizeMb }} MB</small>
            <input #fileInput hidden type="file" [accept]="accept" (change)="onFileChange($event)" />
          </ng-container>

          <ng-template #fileInfo>
            <div class="file-pill">
              <i class="pi pi-file mr-2"></i>
              <span class="truncate">{{ file?.name }} • {{ (file?.size || 0) / 1024 | number:'1.0-0' }} KB</span>
              <p-button icon="pi pi-times" [rounded]="true" (onClick)="removeFile()">
              </p-button>
            </div>
          </ng-template>
        </div>

        <div class="error-message" *ngIf="fileError">{{ fileError }}</div>
        <div class="error-message" *ngIf="ctrl('File').touched && ctrl('File').invalid">
          Selecione um ficheiro
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <p-button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="close()"></p-button>
      <p-button pButton type="submit" label="Carregar" icon="pi pi-upload" class="p-button-primary"
        [disabled]="form.invalid || uploading"></p-button>
    </div>
  </form>
</div>

<p-toast /> <p-confirmDialog></p-confirmDialog>
